import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DannoBiologico } from '../../../../models/danno-biologico/danno-biologico';

@Component({
  selector: 'app-personalizzazione-danno-biologico-view',
  templateUrl: './personalizzazione-danno-biologico-view.component.html',
  styleUrls: ['./personalizzazione-danno-biologico-view.component.css']
})
export class PersonalizzazioneDannoBiologicoViewComponent implements OnInit {

  @Output() openModificaDatiModal = new EventEmitter();
  @Input() dannoBiologico: DannoBiologico;
  constructor() { }

  ngOnInit() {
    console.log(this.dannoBiologico)
  }

  onOpenModificaDati(){
    this.openModificaDatiModal.emit('open')
  }

}
